var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.317 18.523a1.33 1.33 0 0 1-1.88-1.879l3.358-3.357H4.33a1.33 1.33 0 0 1 0-2.659h12.468l-3.36-3.36a1.33 1.33 0 0 1 1.88-1.879l5.058 5.059a2.133 2.133 0 0 1 0 3.016l-5.058 5.059Z",
    fill: "#EDEDF9"
  })));
};
export default SvgRightArrow;